import { Injectable } from '@angular/core';
import { StorageHelper } from '@diktup/frontend/helpers';
import {
  LandingPagesType,
  LandingPageTypeEnum,
  FindLandingPagesByUrlGQL,
  FindLandingPagesByTargetAndTypePaginatedGQL,
  PaginatedLandingPagesWithoutTranslationType,
} from '@sifca-monorepo/ecommerce-generator';
import { BehaviorSubject, Observable, tap, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LandingPagesService {
  private landingPages: BehaviorSubject<PaginatedLandingPagesWithoutTranslationType> = new BehaviorSubject(null);
  private landingPage: BehaviorSubject<LandingPagesType | null> = new BehaviorSubject(null);
  private pageLoading: BehaviorSubject<boolean> = new BehaviorSubject(false);

  get pageLoading$(): Observable<boolean> {
    return this.pageLoading.asObservable();
  }
  
  constructor(
    private storageHelper: StorageHelper,
    private findLandingPagesByUrlGQL: FindLandingPagesByUrlGQL,
    private findLandingPagesByTargetAndTypePaginatedGQL: FindLandingPagesByTargetAndTypePaginatedGQL,
  ) {}

  limit = 9;
  page = 0;

  get landingPages$(): Observable<PaginatedLandingPagesWithoutTranslationType> {
    return this.landingPages.asObservable();
  }

  get landingPage$(): Observable<LandingPagesType> {
    return this.landingPage.asObservable();
  }

  getPagesByURL(pos: string, url: string): Observable<LandingPagesType> {
    return this.findLandingPagesByUrlGQL.fetch({ url, target: { pos } }).pipe(
      map((response: any) => {
        return response.data.findLandingPagesByUrl;
      }),
    );
  }

  findLandingPagesByTargetAndTypePaginated(
    pageType: LandingPageTypeEnum[],
    language?: string,
  ): Observable<PaginatedLandingPagesWithoutTranslationType> {
    this.pageLoading.next(true);
    return this.findLandingPagesByTargetAndTypePaginatedGQL
      .fetch({
        ...(localStorage.getItem('elvklang') ? { language: localStorage.getItem('elvklang') } : language ? { language } : {}),
        pageType,
        target: { pos: this.storageHelper.getData('posId') },
        pagination: { page: this.page, limit: this.limit },
      })
      .pipe(
        map(({ data }: any) => {
          this.pageLoading.next(false);
          this.landingPage.next(data.findLandingPagesByTargetAndTypePaginated.objects[0]);
          this.landingPages.next(data.findLandingPagesByTargetAndTypePaginated);
          return data.findLandingPagesByTargetAndTypePaginated;
        }),
      );
  }

  findContactLandingPagesByTargetAndTypePaginated(pos: string): Observable<LandingPagesType> {
    return this.findLandingPagesByTargetAndTypePaginatedGQL
      .fetch({ pageType: [LandingPageTypeEnum.CONTACT], target: { pos }, pagination: { page: this.page, limit: this.limit } })
      .pipe(
        map((response: any) => {
          if (response.data) {
            this.landingPage.next(response.data.findLandingPagesByTargetAndTypePaginated.objects[0]);
            return response.data.findLandingPagesByTargetAndTypePaginated.objects[0];
          }
        }),
      );
  }

  getPagesByTargetAndURL(pos: string, url: string): Observable<LandingPagesType[]> {
    return this.findLandingPagesByUrlGQL.fetch({ url, target: { pos } }).pipe(
      tap((response: any) => {
        if (response.data) {
          return response.data.findLandingPagesByUrl;
        }
      }),
    );
  }
}
